import styled from 'styled-components';

interface IRootProps {
  textColor?: string;
  placeholderColor?: string;
  backgroundColor?: string;
  show?: string;
  position?: string;
  required?: boolean;
  light?:boolean;
  topContent?: boolean;
  fontFamily?: string;
  shadow?:boolean;
  selected?:boolean;
}

export const Root = styled.div`
  padding: ${(props: IRootProps) => (props.light ? `0px` : `23px 0px 0px 0px`)};
  position: relative;
  width: 100%;
`

export const BoxContainer = styled.div`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: 5px;
  box-shadow: ${(props:IRootProps) => props.shadow ? "0 4px 9px 0 rgba(0, 0, 0, 0.1)" : ""};
  border: solid 1px rgba(130, 130, 130, 0.5);
  background-color: white;
  width: 100%;
  max-width: 100%;
  height: ${(props:IRootProps) => props.light ? "30px" : "40px"};
`

export const SelectContainer = styled.input`
  -moz-appearance:none; /* Firefox */
  -webkit-appearance:none; /* Safari and Chrome */
  appearance:none;
  align-items: center;
  font-family: ${(props: IRootProps) => (props.fontFamily ?? '')}, Rubik;
  border: 0px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  width: calc(100% - 40px);
  height: 100%;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  color: ${(props:IRootProps) => props.textColor ?? 'auto'};
  padding: 0px 10px;
  word-break: break-word;
  &:focus {
    outline-width: 0;
  }
  &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${(props: IRootProps) => (props.placeholderColor ?? 'auto')};
    opacity: 1; /* Firefox */
  }
  &::-ms-input-placeholder { /* Microsoft Edge */
    color: ${(props: IRootProps) => (props.placeholderColor ?? 'auto')};
  }
`

export const ArrowsContainer = styled.div`
  width: 40px;
  height: 100%;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`

export const CheckBoxesContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0px 10px 0px 0px;
  cursor: pointer;
`

export const OptionsContainer = styled.div`
  display: ${(props:IRootProps) => props.show ? props.show : 'none'};
  box-sizing: border-box;
  flex-direction: column;
  position: absolute;
  width: 100%;
  padding: 8px 0px 8px 0px;
  bottom: ${(props:IRootProps) => props.position === "top" ? props.light ? '47px' : '55px' : 'auto'};
  top: ${(props:IRootProps) => props.position === "bottom" ? props.light ? '35px' : props.topContent ? '107px' : '56px' : 'auto'};
  left: 0px;
  flex-grow: 0;
  border-radius: 3px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  z-index: 10;
  max-height: 240px;
  overflow-y: auto; 
`

export const OptionMultiselect = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 10px 8px 10px;
  color: black;
  cursor: pointer;
  font-family: ${(props: IRootProps) => (props.fontFamily ?? '')}, Rubik;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  background-color: ${(props:IRootProps) => props.backgroundColor ? props.backgroundColor : `white`};
  word-break: break-word;
  &:hover {
    background-color: gray
  }
`

export const Option = styled.div`
  padding: 8px 12px 8px 12px;
  display: flex;
  box-sizing: border-box;
  color: black;
  cursor: pointer;
  font-family: ${(props: IRootProps) => (props.fontFamily ?? '')}, Rubik;
  font-size: 14px;  
  font-weight: ${(props:IRootProps) => props.selected ? 'bold' : 'normal'};
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  
  word-break: break-word;
  &:hover {
    background-color: #eef5fe;
  }
`

export const TopContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0px 5px 0px;
`

export const TitleLabel = styled.div`
  font-family: Rubik;
  height: 14px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #204078;
`

export const RequiredLabel = styled.div`
  display: flex;
  flex: 1;
  justify-content: right;
  font-family: Rubik;
  height: 14px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${(props:IRootProps) => props.textColor ? props.textColor : '#8891a0'};
`

export const TipLabel = styled.div`
  height: 14px;
  margin: 6px 0px 0px 0px;
  font-family: Rubik;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  position: absolute;
  bottom: -16px;
  left: 0px;
  color: ${(props:IRootProps) => props.textColor ? props.textColor : '#8891a0'};
`

export const NoResultsFound = styled.div`
  font-family: Rubik;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #8891a0;
`

export const TextContainer = styled.input`
  display: flex;
  align-items: center;
  border: 0px;
  background-color: #ffffff;
  font-family: Rubik;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: italic;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${(props:IRootProps) => props.textColor ? props.textColor : `lightgray`};
  padding: 8px 16px;
  box-sizing: border-box;
  &:focus {
    outline-width: 0;
  }
`